import constructMetaObject from './constructMetaObject'
import groupBy from 'lodash.groupby'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformLocalizationInfo (data) {
	return applyToOneOrMany(_transformLocalizationInfo, data)
}

function _transformLocalizationInfo (post) {
	post.lang = post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch'

	if (post.polylang.translations) {
		const firstAlternateLanguage = Object.keys(post.polylang.translations)[0]
		post.alternateLanguage = {
			lang: firstAlternateLanguage === 'en' ? 'en-us' : 'de-ch',
			slug: post.polylang.translations[firstAlternateLanguage].slug
		}
	} else {
		post.alternateLanguage = {
			lang: post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch',
			slug: post.slug
		}
	}

	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformLocalizationInfo.js